/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useContext } from 'react'

/**
 * Determines whether we should display the "Schools" section higher on the page
 */
export const useHigherEducation = () => {
  const { optimizely } = useContext(OptimizelyContext)
  if (!optimizely) {
    return false
  }
  const variation = optimizely.activate('HIGHER_EDUCATION')
  return variation === 'test'
}
